import React from 'react';
import clientInformation from '../login/ClientInfo';
import { RequestEWalletPayout, GetPayoutFee, CoinflowRegisterUser, CoinflowRegisterCard } from "../../services/PayoutService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import Loading from '../helpers/Loader';
import { IsValidToken } from "../../services/AuthenticationService";
import BeatLoader from "react-spinners/BeatLoader";
import { onlyNumbers, BonusString } from '../helpers/common';
import { isMobile } from 'react-device-detect';
import { CoinflowCardNumberForm, CardFormRef } from '@coinflowlabs/react';
import swal from 'sweetalert2';

export const PayoutCoinflowMethods = () => {
    const clientInfo = clientInformation();
    let INSTANCEID = clientInfo.InstanceID;
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    const [isProcessing, setIsProcessing] = useState(false);
    const { id } = useParams();
    const [arrayPayouts, setPayouts] = useState(JSON.parse(localStorage.getItem('arrayPayoutsMethods')).filter(function (element) { return element.PayoutID === id; })[0]);
    const navigate = useNavigate();
    const [showComponent, setshowComponent] = useState(false);
    const [OriginalAmount, setOriginalAmount] = useState(0);
    const [Fee, setFee] = useState('');
    const showCoins = sessionStorage.getItem('displaycoin') === "true";
    const [showiFrame, setshowiFrame] = useState(false);
    const [showFrameTitle, setShowFrameTitle] = useState(true);
    const [showForm, setshowForm] = useState(false);
    const [height, setHeight] = useState('500px');
    const iframeRef = React.useRef(null);
    const [urlVerification, setUrlVerification] = useState('');
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    // Coinflow card tokenization
    const coinflowRef = useRef(null);
    const [cardToken, setCardToken] = useState('');
    const [showCardForm, setShowCardForm] = useState(false);
    const [cardRegistrationLoading, setCardRegistrationLoading] = useState(false);

    useEffect(() => {
        IsValidToken(localStorage.getItem('Token')).then(
            GetPayoutFee(localStorage.getItem('Token'), arrayPayouts?.PayoutID).then(function (response) {
                var MinFee = parseFloat(response.Authentication.MinFee);
                var PerFee = parseFloat(response.Authentication.PerFee);
                var FlatFee = parseFloat(response.Authentication.FlatFee);
               
                if (MinFee > 0)
                    setFee(MinFee);
                else if (PerFee > 0)
                    setFee(PerFee + "% ");
                else if (FlatFee > 0)
                    setFee(FlatFee);
            })

        )
        .catch(function (error) {
            navigate('/expired/');
        })

        if (arrayPayouts === undefined) {
            navigate('/payouts/');
        }

        Alerts.ShowMessageLoader('Please wait', 'Please wait while we run verification steps...', 'info');

        setTimeout(() => {
            doCoinflowRegisterUser();
        }, 4000);

    }, [])

    //CoinflowRegisterUser
    async function doCoinflowRegisterUser() {
        swal.close();
            var PayoutData = {
                "Token": localStorage.getItem('Token'),
                "CustomerID": localStorage.getItem('CustomerID'),
                "PayoutName": arrayPayouts.PayoutName
            };
        setIsProcessing(true);
        await CoinflowRegisterUser(PayoutData).then(function (response) {
            var statusCode = response.Authentication.StatusCode;
            var message = response.Authentication.Message;


                if (statusCode === 200) {
                    
                    /*if (isMobile)
                        Alerts.ShowAlertFullScreen('Verification Status', message, 'info');
                    else
                        Alerts.ShowAlert('Verification Status', message, 'info');*/
                    setshowiFrame(false);
                    setshowForm(false);
                    setIsProcessing(false);
                    setShowCardForm(true);
                    forceUpdate();

                } else if (statusCode === 451) {
                    // Unavailable for Legal Reasons - redirect link 
                    //window.location.href = message;
                    var Link = message;
                    if (Link != "" && Link != undefined && URL.canParse(Link)) {
                        setUrlVerification(Link);
                        setIsProcessing(false);
                        setshowiFrame(true);
                        setshowForm(false);
                        forceUpdate();
                    }
                    else {
                        if (isMobile)
                            Alerts.ShowAlertFullScreen('Verification Status', 'Invalid Verification User', 'warning');
                        else
                            Alerts.ShowAlert('Verification Status', 'Invalid Verification User', 'warning');

                        navigate('/payouts/');
                    }


                } else if (statusCode === 409) {
                    // Conflict Error
                    if (isMobile)
                        Alerts.ShowAlertFullScreen('Verification Status', message, 'warning');
                    else
                        Alerts.ShowAlert('Verification Status', message, 'warning');

                    navigate('/payouts/');

                } else {
                    
                    if (isMobile)
                        Alerts.ShowAlertFullScreen('Verification Status', message, 'warning');
                    else
                        Alerts.ShowAlert('Verification Status', message, 'warning');

                    navigate('/payouts/');
            }
            setIsProcessing(false);
            })
            .catch(function (error) {
                const errorMessage = error?.response?.data?.Authentication?.HtmlResponse
                    || error?.message
                    || 'An unexpected error occurred';
                Alerts.ShowAlert('Verification Status', errorMessage, 'error');
                navigate('/payouts/');
            })

    }

    // Tokenize Card
    const handleGetToken = async () => {
        try {
            setCardRegistrationLoading(true);

            let result;
            try {
                result = await coinflowRef.current?.tokenize();
            } catch (tokenizeError) {
                setCardRegistrationLoading(false);
                Alerts.ShowAlert('Invalid Card', 'Please enter a valid card number before continuing.', 'warning');
                return;
            }
            
            if (!result?.token) {
                setCardRegistrationLoading(false);
                Alerts.ShowAlert('Invalid Card', 'Please enter a valid card number before continuing.', 'warning');
                return;
            }
            var RegisterData = {
                "Token": localStorage.getItem('Token'),
                "CustomerID": localStorage.getItem('CustomerID'),
                "PayoutName": arrayPayouts.PayoutName,
                "CardToken": result.token,
                "ExpYear": result.expYear,
                "ExpMonth": result.expMonth
            };

            var cardRegistered = await CoinflowRegisterCard(RegisterData);
            var success = cardRegistered.Authentication.Success;
            var message = cardRegistered.Authentication.Message;

            if (success === false) {
                Alerts.ShowAlert('Unable to verify card', 'We were unable to verify your card at this time. Please try again later or use a different card.', 'error');
                return;
            }
 
            setCardToken(result.token);
            await new Promise(resolve => setTimeout(resolve, 4000));
            setCardRegistrationLoading(false);
            setShowCardForm(false);
            setshowForm(true);

        } catch (err) {
            Alerts.ShowAlert('Unable to verify card', 'We were unable to verify your card at this time. Please try again later or use a different card.', 'error');
        } finally {
           setCardRegistrationLoading(false);
        }
    };

    async function doRequestEWalletPayout(Amount, comments) {
        if (parseFloat(Amount.replace(",", "").replace(" ", "")) <= parseFloat(clientInfo.WithdrawalBalance.replace(",", "")) && parseFloat(Amount.replace(",", "").replace(" ", "")) > 0) {
            var PayoutData  = {
                "Token": localStorage.getItem('Token'),
                "Amount": Amount.replace(",", ""),
                "CurrencyCode": clientInfo.CurrencyCode,
                "ProcessorName": arrayPayouts?.PayoutID,
                "EWalletID": cardToken,
                "SecureID": "",
                "IPv4Address": clientInfo.IPAddress,
                "Comments": comments,
                "Udf1": clientInfo.Udf1
                };

            await RequestEWalletPayout(PayoutData).then(function (response) {
                if (response.Authentication.ErrorCode === "") {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen('Redemption Status', response.Authentication.HtmlResponse.replace(/payout/gi, 'Redemption'), 'info');
                    else
                        Alerts.ShowAlert('Redemption Status', response.Authentication.HtmlResponse.replace(/payout/gi, 'Redemption'), 'info');
                    navigate('/payouts/');
                } else {
                    if (isMobile)   
                        Alerts.ShowAlertFullScreen('Redemption Status', response.Authentication.HtmlResponse.replace(/payout/gi, 'Redemption'), 'warning');
                    else
                        Alerts.ShowAlert('Redemption Status', response.Authentication.HtmlResponse.replace(/payout/gi, 'Redemption'), 'warning');
                }
            })
                .catch(function (error) {
                    Alerts.ShowAlert('Redemption Status', 'We were unable to request the redemption. Please try later.', 'error');
                    //Alerts.ShowAlert('Error', 'Error making deposit', 'error');
                })
        }
        else {
            if (isMobile)
                Alerts.ShowAlertFullScreen('Redemption Status', 'amount not permitted, please check your redemption balance', 'warning');
            else
                Alerts.ShowAlert('Redemption Status', 'amount not permitted, please check your redemption balance', 'warning');
        }

    }

    const handleSubmit = async (event) => {
        event.preventDefault();        
        if (!isProcessing) {
            var data = new FormData(event.target);
            let { amount  } = Object.fromEntries(data.entries());
            
            if (amount != '') {
                setIsProcessing(true);
                setOriginalAmount(amount);
                await doRequestEWalletPayout(amount, '', '');
                setIsProcessing(false);
                

            }
            else {
                Alerts.ShowAlert('Warning', 'Amount required', 'warning');
            }

        }
    }

    const handleIframeLoad = () => {
        setShowFrameTitle(false);
    }

    return (
        <div className="componentload">
            <form onSubmit={handleSubmit}>
                <div className="row m-4">
                    <span className="icon-single-left txt-primary">
                        <img style={{ width: "100px", height: "100px" }} src={"/svg/" + arrayPayouts?.ImageName + ".svg"} />  <span className="payout-title">Redem using Push to Card </span>
                    </span>
                </div>
                {showiFrame && <div>
                    {showFrameTitle && <h5 id="frameTitle">Please wait, your form will load in a few seconds...</h5>}
                    <iframe
                        ref={iframeRef}
                        style={{ overflow: "scroll" }}
                        onLoad={handleIframeLoad}
                        src={urlVerification}
                        height={height}
                        width='100%'
                        scrolling="yes"
                        allow="payment; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture full">
                    </iframe>
                </div>}
                {/* Header Steps */}
                <div className="row m-4">
                    <div className="col-md-6 col-sm-12">
                        <p className="text-muted mb-3">Please complete this 2 step process.</p>
                        <div className="d-flex align-items-center gap-3">
                            {/* Step 1 */}
                            <div className="d-flex align-items-center gap-2">
                                <div style={{
                                    width: '28px', height: '28px', borderRadius: '50%',
                                    background: showCardForm ? '#2558a8' : '#28a745',
                                    color: '#fff', display: 'flex', alignItems: 'center',
                                    justifyContent: 'center', fontSize: '13px', fontWeight: '700',
                                    flexShrink: 0
                                }}>
                                    {showCardForm ? '1' : '\u2713'}
                                </div>
                                <span style={{ fontSize: '13px', color: showCardForm ? '#2558a8' : '#28a745', fontWeight: showCardForm ? '600' : '400' }}>
                                    Enter the card to request the redemption.
                                </span>
                            </div>

                            {/* L�nea conectora */}
                            <div style={{ flex: 1, height: '2px', background: showForm ? '#28a745' : '#dee2e6', maxWidth: '60px' }} />

                            {/* Step 2 */}
                            <div className="d-flex align-items-center gap-2">
                                <div style={{
                                    width: '28px', height: '28px', borderRadius: '50%',
                                    background: showForm ? '#2558a8' : '#dee2e6',
                                    color: showForm ? '#fff' : '#aaa', display: 'flex', alignItems: 'center',
                                    justifyContent: 'center', fontSize: '13px', fontWeight: '700',
                                    flexShrink: 0
                                }}>
                                    2
                                </div>
                                <span style={{ fontSize: '13px', color: showForm ? '#2558a8' : '#aaa', fontWeight: showForm ? '600' : '400' }}>
                                    Fill the redemption amount.
                                </span>
                            </div>
                        </div>
                        <hr className="mt-3" />
                    </div>
                </div>

                {/* Step 1 - Card Form env={'sandbox'} for testing - env={'prod'} for production */}
                {showCardForm && <div className="row m-4">
                    <div className="col-md-6 col-sm-12">
                        <h6 className="mb-3">Register your debit card</h6>

                        <div className="mb-3" style={{ height: '50px' }}>
                            <CoinflowCardNumberForm
                                merchantId={'bracco'}
                                ref={coinflowRef}
                                env={'prod'}
                                theme={{
                                    fontSize: '13px',
                                    background: '#ffffff',
                                    textColor: '#000000',
                                    cardNumberPlaceholder: '0000 0000 0000 0000',
                                    expirationPlaceholder: 'MM / YY',
                                }}
                                onLoad={() => console.log('Coinflow card number form loaded')}
                            />
                        </div>

                        {cardRegistrationLoading && (
                            <div className="d-flex align-items-center gap-2 mb-3">
                                <BeatLoader size={8} color="#2558a8" />
                                <span style={{ fontSize: '13px', color: '#2558a8', fontWeight: '600' }}>
                                    Card verification in progress...
                                </span>
                            </div>
                        )}
                    </div>
                </div>}

                {/* Step 2 - Amount Form */}
                {showForm && <div className="row">
                    <div className="col-md-6 col-sm-12 m3">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-currency-cards d-none d-md-block" id="lblCurrency">
                                    <select className="form-control selectcurrency" disabled name="ccCurrency" required value={clientInfo.CurrencyCode}>
                                        <option value="" className="">Currency</option>
                                        <option value="USD">USD</option>
                                    </select>
                                </span>
                            </div>
                            <input type="number" onKeyPress={(event) => onlyNumbers(event)} aria-label="Amount (to the nearest dollar)" className="form-control" id="amount" aria-describedby="lblCurrency" placeholder="Amount" max={arrayPayouts?.MaxPayout === 0 ? MAXLIMIT : arrayPayouts?.MaxPayout} min={arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} name="amount" required="required" />
                        </div>

                        <div className="d-flex flex-row ml-2 limit-text-center mb-4 ">
                            Redemption Limits: Minimum {arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} USD Maximum {arrayPayouts?.MaxPayout === 0 ? 'No Limit' : arrayPayouts?.MaxPayout + ' USD'}
                        </div>
                    </div>
                </div>}
                
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12 " >

                    </div>
                    <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4" onClick={() => navigate('/payouts/')}>BACK</button>
                        {showCardForm ? (
                            <button
                                type="button"
                                    className="btn btn-deposit btn-deposit-order mb-4"
                                onClick={handleGetToken}
                                disabled={isProcessing}>
                                {isProcessing ? <BeatLoader size={8} color="#fff" /> : 'Next'}
                            </button>
                        ) : (
                            !showiFrame && <button type="submit" className="btn btn-deposit btn-deposit-order mb-4 submit">REDEMPTION</button>
                        )}
                    </div>
                </div>


            </form>
            <div>
                {isProcessing && <Loading/>}
            </div>
        </div>
    );

}